import download from './images/download.svg'

export default function DownloadIcon(props) {
  return (
    <img src={download} alt="download" onClick={props.onClick} />
  )
}
